/* El navbar es position:fixed (alto --navbar-height). En el landing el offset lo
   da el Hero; las páginas de contenido no tienen Hero, así que lo compensa el
   propio <main> con padding-top. min-height asegura que el footer no suba en
   páginas cortas. */
.main {
  padding-top: var(--navbar-height);
  min-height: 100vh;
  background: var(--color-bg);
  color: var(--color-text);
}
